module.exports = __webpack_public_path__ + "static/media/orderChecked.afe17fb6.svg";